import { render, staticRenderFns } from "./orderListItem.vue?vue&type=template&id=52f8b4a9&scoped=true"
import script from "./orderListItem.vue?vue&type=script&lang=js"
export * from "./orderListItem.vue?vue&type=script&lang=js"
import style0 from "./orderListItem.vue?vue&type=style&index=0&id=52f8b4a9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52f8b4a9",
  null
  
)

export default component.exports